export default {
  en: {
    title: 'Interests',
    loading: 'Loading',
    loadError: 'Failed to load',
  },
  ru: {
    title: 'Интересы',
    loading: 'Загружаю',
    loadError: 'Не удалось загрузить',
  },
  de: {
    title: 'Interessen',
    loading: 'Lädt',
    loadError: 'Laden fehlgeschlagen',
  },
  pt: {
    title: 'Interesses',
    loading: 'Carregando',
    loadError: 'Falha ao carregar',
  },
  fr: {
    title: 'Centres d’intérêt',
    loading: 'Chargement',
    loadError: 'Échec du chargement',
  },
  es: {
    title: 'Intereses',
    loading: 'Cargando',
    loadError: 'No se pudo cargar',
  },
};
